import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { requestAnimationFrame } from "./requestAnimationFrame";

export function mapVideoToCanvas(
  video: HTMLVideoElement,
  canvas: HTMLCanvasElement,
  options?: { toFlip: boolean }
) {
  return new Observable<void>((subscriber) => {
    updateCanvas(video, canvas, options?.toFlip || false);

    const sub1 = requestAnimationFrame()
      .pipe(
        tap(() => drawImageFromVideoToCanvas(video, canvas)),
        tap(() => subscriber.next())
      )
      .subscribe();

    return () => {
      sub1.unsubscribe();
    };
  });
}

function drawImageFromVideoToCanvas(
  video: HTMLVideoElement,
  canvas: HTMLCanvasElement
) {
  const ctx = canvas.getContext("2d");

  try {
    ctx!.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
  } catch (_) {
    /* eslint:disable:no-empty */
  }
}

function updateCanvas(
  video: HTMLVideoElement,
  canvas: HTMLCanvasElement,
  toFlip: boolean
) {
  const ctx = canvas.getContext("2d");

  if (
    canvas.width !== video.videoWidth ||
    canvas.height !== video.videoHeight
  ) {
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
  }

  const { isIdentity } = ctx!.getTransform();
  // flip only once
  if (toFlip && isIdentity) {
    ctx!.translate(canvas.width, 0);
    ctx!.scale(-1, 1);
  }
}
